import { baseApi } from './base';
import { FleetRef } from '../domain/fleet-verification';

export const fleetVerificationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFleets: builder.query<FleetRef[], void>({
      query: () => ({
        method: 'GET',
        url: 'qualification/fleet-verification/fleets',
      }),
    }),
    resetToPhoneAuth: builder.mutation<void, void>({
      query: () => ({
        method: 'POST',
        url: 'qualification/fleet-verification/reset-to-phone-auth',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetFleetsQuery, useResetToPhoneAuthMutation } = fleetVerificationApi;
